import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Announcements Config"})
export default class PanelConfig {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine Panel"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "View All Link"})
	public enableViewAllLink?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show load more"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Announcements to display"})
	public pageSize?: number = 3;

}



// WEBPACK FOOTER //
// ./src/panels/announcements/Config.ts